import { IModalProvider } from '@base/features/modal/model/interfaces';
import { ColumnType } from '@base/ui/components/dataTable';
import { t } from '@base/utils/helpers';
import { container } from 'tsyringe';
import { GamesHistory, IGamesHistoryService, Session } from '../model/interfaces';
import styles from '../styles/gameHistory.module.scss';

const commonColumns: ColumnType<GamesHistory>[] = [
  {
    title: '',
    dataIndex: 'sreason',
    style: { width: '15%' },
    render: (history) => <span>{history.sreason || ' '}</span>,
  },
  {
    title: 'time_est',
    dataIndex: 'Date',
    render: (history) => <span>{history.Date}</span>,
  },
  {
    title: 'opt',
    dataIndex: 'Options',
    render: (history) => <span>{history.Options}</span>,
  },
  {
    title: 'event',
    dataIndex: 'Amount',
    render: (history) => <span>{`$ ${history.Amount}`}</span>,
  },
];


export const gameHistoryColumnsForAdmins = (
  currentUser: Session,
  gameId?: number
): ColumnType<GamesHistory>[] => {
  return [
    {
      title: 'players',
      style: { width: '35%' },
      dataIndex: 'Usr1',
      render: (history) => {
        return (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={`https://www.gamecolony.com/viewer-backgammon/gameview.html?id=${gameId}&id=${history.GameLogID}&usr=${currentUser.usr}&sid=${currentUser.session}`}
          >
            <div className={styles.players}>
              <div className="avatar-overlay" style={{ height: '20px', width: '20px' }}>
                <img
                  className="avatar"
                  src={`https://www.gamecolony.com/cgi-bin/get_avatar.plx?uid=${history.Player1}&size=2`}
                  alt="avatar"
                />
              </div>
              <span>{history.Usr1}</span>
              <span>vs</span>
              <div className="avatar-overlay" style={{ height: '20px', width: '20px' }}>
                <img
                  className="avatar"
                  src={`https://www.gamecolony.com/cgi-bin/get_avatar.plx?uid=${history.Player2}&size=2`}
                  alt="avatar"
                />
              </div>
              <span>{history.Usr2}</span>
            </div>
          </a>
        );
      },
    },
    {
      title: '',
      dataIndex: 'matlnk',
      render: (history) => history.GameLogID && <View GameLogID={history.GameLogID} />,
    },
    ...commonColumns,
  ];
};

export const gameHistoryColumnsForPlayers: ColumnType<GamesHistory>[] = [
  {
    title: 'players',
    style: { width: '35%' },
    dataIndex: 'Usr1',
    render: (history) => {
      return (
        <div className={styles.players}>
          <div className="avatar-overlay" style={{ height: '20px', width: '20px' }}>
            <img
              className="avatar"
              src={`https://www.gamecolony.com/cgi-bin/get_avatar.plx?uid=${history.Player1}&size=2`}
              alt="avatar"
            />
          </div>
          <span>{history.Usr1}</span>
          <span>vs</span>
          <div className="avatar-overlay" style={{ height: '20px', width: '20px' }}>
            <img
              className="avatar"
              src={`https://www.gamecolony.com/cgi-bin/get_avatar.plx?uid=${history.Player2}&size=2`}
              alt="avatar"
            />
          </div>
          <span>{history.Usr2}</span>
        </div>
      );
    },
  },
  ...commonColumns,
];

const View = (props: { gameId?: number; GameLogID: number }) => {
  const modalProvider: IModalProvider = container.resolve('modalProvider');
  const gamesHistoryService: IGamesHistoryService = container.resolve('gamesHistoryService');

  const getModalWithLog = async () => {
    const log = await gamesHistoryService.getGameLog(props.GameLogID);
    modalProvider.show({
      title: t('games_log'),
      body: <pre className={styles.logBody}>{log}</pre>,
      buttons: [{ title: t('ok'), onClick: () => modalProvider.hide() }],
    });
  };
  return (
    <button className={styles.matBtn} onClick={getModalWithLog}>
      {t('view')}
    </button>
  );
};
